import { signInWithRedirect } from "aws-amplify/auth";
import mixpanel from "mixpanel-browser";

import { configureSsoPool } from "./amplifyConfig";

/**
 * Starts the Duo SSO round trip: switches Amplify to the SSO user pool, then
 * hands the browser to the hosted UI. Tokens arrive on the way back via the
 * `?code=` handled in amplifyConfig.
 *
 * Deliberately not part of the authProvider: this navigates away, so there is no
 * result for react-admin's useLogin to act on, and the authProvider is a fixed
 * react-admin interface. Call it straight from the UI instead.
 */
export async function loginWithDuo(): Promise<void> {
  mixpanel.track("signIn", { username: "duo" });
  configureSsoPool();
  await signInWithRedirect({ provider: { custom: "Duo" } });
}
